import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TransformedStory } from '../../interfaces/success-story.interface';

@Component({
    selector: 'app-success-story-item',
    standalone: true,
    imports: [],
    templateUrl: './success-story-item.component.html',
    styleUrl: './success-story-item.component.scss',
})
export class SuccessStoryItemComponent implements OnInit {
    @Input() image: string = '';
    @Input() portrait: string = '';
    @Input() mobile: string = '';
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() shortdesc: string = '';
    @Input() storyData: TransformedStory | null = null;
    @Output() itemClick = new EventEmitter<TransformedStory>();
    slug: string = '';

    ngOnInit(): void {
        this.slug = this.title?.replaceAll(' ', '_')?.toLowerCase();
    }

    onItemClick() {
        const story: TransformedStory = this.storyData || {
            image: this.image,
            title: this.title,
            description: this.description,
            shortdesc: this.shortdesc,
        };
        this.itemClick.emit(story);
    }
}
